import { render } from "./SessionForm.vue?vue&type=template&id=1f39dfb7"
import script from "./SessionForm.vue?vue&type=script&lang=js"
export * from "./SessionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__